import firebaseConfig from "../firebase";

const bookReserRef = firebaseConfig.firestore().collection("Book_reservation");
const bookRef = firebaseConfig.firestore().collection("Book");
const userRef = firebaseConfig.firestore().collection("User");
const commentListRef = firebaseConfig.firestore().collection("Comment_list");
const readingRoomRef = firebaseConfig.firestore().collection("Reading_room");
const seatRef = firebaseConfig.firestore().collection("Seat");
const userModelRef = firebaseConfig.firestore().collection("User_model");
const modelRef = firebaseConfig.firestore().collection("Model");
const seatReservationRef = firebaseConfig
  .firestore()
  .collection("Seat_reservation");
/**
 * ========================================== BOOK ==========================================
 */
/**
 * Get Book by id
 * @param id: book id
 */
async function getBookByIdApi(id) {
  return await new Promise((resolve, reject) => {
    firebaseConfig
      .firestore()
      .collection("Book")
      .onSnapshot((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => {
          items.push(doc.data());
        });

        // Traverse all the data,
        // find the data whose book_id is the same as the id passed in
        let res = {};
        for (let i = 0; i < items.length; i++) {
          if (items[i]["book_id"] === id) {
            res = items[i];
          }
        }

        if (JSON.stringify(res) === "{}") {
          reject({
            status: 300,
            msg: "Get book failed " + id,
          });
        }

        // if success
        resolve({
          status: 200,
          msg: "ok",
          data: res,
        });
      });
  });
}

/**
 * Get Book recommend List by book amount
 * @param amount: book amount
 * @return: a list of recommend book details
 * @usage: getBookRecommendListApi(2)
 */
async function getBookRecommendListApi(amount) {
  return await new Promise((resolve, reject) => {
    bookRef.onSnapshot((querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push(doc.data());
      });

      // 1. Sort => by recommend
      items.sort(function (a, b) {
        return b["recommend"] - a["recommend"];
      });

      // 2. Return the corresponding quantity according to amount
      let recommend_list = items.slice(0, amount);

      // 3. Select the corresponding attribute
      let res = recommend_list.map(function (item) {
        return {
          book_id: item.book_id,
          book_name: item.book_name,
          book_url: item.book_url,
          thumbnail: item.thumbnail,
        };
      });

      if (!res) {
        reject({
          status: 300,
          msg: "Get recommend list failed",
        });
      }

      resolve({
        status: 200,
        msg: "ok",
        data: res,
      });
    });
  });
}

/**
 * Get book info by category
 * @param category: book category
 * @return: a list of books based on category
 * @usage: getCategories("Fiction")
 */
async function getCategoriesApi(category) {
  return await new Promise((resolve, reject) => {
    // Traverse all the data
    bookRef.onSnapshot((querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push(doc.data());
      });

      //get the category
      let category_list = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i]["category"] === category) {
          category_list.push(items[i]);
        }
      }

      //get data based on category
      let res = category_list.map(function (item) {
        return {
          category: item.category,
          book_id: item.book_id,
          book_name: item.book_name,
          author: item.author,
          book_url: item.book_url,
          thumbnail: item.thumbnail,
          recommended_amount: item.recommended_amount,
        };
      });

      if (!res)
        reject({
          status: 300,
          msg: "get category " + category,
        });

      // if success
      resolve({
        status: 200,
        msg: "ok",
        data: res,
      });
    });
  });
}

/**
 * get all the book
 * @returns: all the list of book
 */
async function getAllBookApi() {
  return await new Promise((resolve, reject) => {
    // Traverse all the data
    bookRef.onSnapshot((querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push(doc.data());
      });

      //get all the book
      let res = items.map(function (item) {
        return {
          book_id: item.book_id,
          category: item.category,
          book_name: item.book_name,
          author: item.author,
          book_url: item.book_url,
          thumbnail: item.thumbnail,
          recommended_amount: item.recommended_amount,
        };
      });

      //if failed
      if (!res)
        reject({
          status: 300,
          msg: "get all the book failed ",
        });

      // if success
      resolve({
        status: 200,
        msg: "ok",
        data: res,
      });
    });
  });
}

/**
 * change the book status
 * @param {*} info : book id and status
 * @returns status:200, msg:"ok"
 */

async function renewBookStatus(info) {
  return await new Promise((resolve, reject) => {
    bookRef
      .where("book_id", "==", info["book_id"])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item["status"] = info["status"];

          // renew the field value below if the info contains it
          bookRef
            .doc(info["book_id"])
            .update(item)
            .then(() => {
              resolve({
                statue: 200,
                msg: "ok",
              });
            })
            .catch((error) => {
              reject({
                statue: 300,
                msg: "Error update book status! " + error,
              });
            });
        });
      });
  });
}

/**
 *  insert book reservation info to database
 * @param  info : contain book reservation information
 * @returns status:200, msg:"ok"
 * usage: rentBookAddApi(infoObj)
 */

async function addBookRentApi(info) {
  return await new Promise((resolve, reject) => {
    // get time and calculate time +7days
    let timestamp = new Date().getTime();
    let date = new Date(timestamp);
    date.setDate(date.getDate() + 7);
    let newTimestamp = date.getTime();

    bookReserRef
      .add(info)
      .then((docRef) => {
        //update the document with extra info
        info["reservation_id"] = docRef.id;
        info["create_time"] = timestamp;
        info["return_time"] = newTimestamp;
        info["is_delete"] = false;
        docRef.update(info);

        //renew the status in book
        renewBookStatus({
          book_id: info["book_id"],
          status: false,
        });

        resolve({
          status: 200,
          msg: "ok",
        });
      })

      .catch((error) => {
        reject({
          status: 300,
          msg: "Error add book renting" + error,
        });
      });
    bookRef
      .doc(info.book_id)
      .get()
      .then((doc) => {
        doc.ref.update({
          ...doc.data(),
          read_amount: doc.data()["read_amount"] + 1,
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "update read amount" + error,
        });
      });
  });
}

/**
 * update recommend amount based on book id
 * @param {*} info :book_id, recommend:+1, -1
 * @returns status:200, msg:ok
 * usage: updateRecommendAmountApi(infoObj)
 */
async function updateRecommendAmountApi(info) {
  return await new Promise((resolve, reject) => {
    bookRef
      .doc(info.book_id)
      .get()
      .then((doc) => {
        doc.ref.update({
          ...doc.data(),
          recommended_amount:
            doc.data()["recommended_amount"] + info["recommend"],
        });
        resolve({
          status: 200,
          msg: "ok",
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "update recommend amount" + error,
        });
      });
  });
}

/**
 * update booking renting info
 * @param info: renting book status info
 * @returns status:200, msg:"ok"
 */
async function updateRentBookApi(info) {
  return await new Promise((resolve, reject) => {
    // check the content of info in database based on reservation_id
    bookReserRef
      .doc(info.reservation_id)
      .get()
      .then((doc) => {
        let item = doc.data();

        // renew the field value below if the info contains it
        item["user_id"] = info["user_id"] || item["user_id"];
        item["is_delete"] = info["is_delete"] || item["is_delete"];
        item["book_id"] = info["book_id"] || item["book_id"];
        item["start_time"] = info["start_time"] || item["start_time"];
        item["end_time"] = info["end_time"] || item["end_time"];

        // update info based on reservation_id
        doc.ref
          .update(item)
          .then(() => {
            resolve({
              status: 200,
              msg: "ok",
            });
          })
          .catch((error) => {
            reject({
              status: 300,
              msg: "Error update renting status! " + error,
            });
          });

        // renew the status in book
        renewBookStatus({
          book_id: item["book_id"],
          status: true,
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error update renting status! " + error,
        });
      });
  });
}

/**
 * get all the comment in one book
 * @param {*} id :book_id
 * @returns :book_id,comment_id,user_id,user_name,content,comment_page,create_time
 * Usage: getAllCommentByBookIdApi()
 */
async function getAllCommentByBookIdApi(id) {
  return await new Promise((resolve, reject) => {
    // traverse all the data from comment list
    commentListRef
      .where("book_id", "==", id)
      .where("is_delete", "==", false)
      .get()
      .then((querySnapshot) => {
        let promises = [];
        let comments = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();

          let tmp = {
            book_id: item.book_id,
            comment_id: item.comment_id,
            user_id: item.user_id,
            user_name: null,
            content: item.content,
            comment_page: item.comment_page,
            create_time: item.create_time,
          };

          let promise = userRef
            .where("user_id", "==", item.user_id)
            .get()
            .then((querySnapShot) => {
              querySnapShot.forEach((userDoc) => {
                tmp["user_name"] = userDoc.data().user_name;
              });
            })
            .catch((err) => {
              throw new Error("Error: get book comment: " + err);
            });
          promises.push(promise);
          comments.push(tmp);
        });

        Promise.all(promises)
          .then(() => {
            resolve({
              status: 200,
              msg: "ok",
              data: comments,
            });
          })
          .catch((err) => {
            reject({
              status: 300,
              msg: "Error: get book comment: " + err,
            });
          });
      })
      .catch((err) => {
        reject({
          status: 300,
          msg: "Error: get book comment: " + id,
        });
      });
  });
}

/**
 * add a user's comment of a book.
 * @param {*} info :
 * @returns status:200,msg:ok
 * usage: addCommentByBookIdApi(infoObj)
 */
async function addCommentByBookIdApi(info) {
  return await new Promise((resolve, reject) => {
    commentListRef
      .add(info)
      .then((doc) => {
        info["create_time"] = getTimestamp();
        info["is_delete"] = false;
        info["comment_id"] = doc.id;
        doc.update(info);

        resolve({
          status: 200,
          msg: "ok",
          data: {
            comment_id: info.comment_id,
          },
        });
        bookRef
          .doc(info.book_id)
          .get()
          .then((doc) => {
            doc.ref.update({
              ...doc.data(),
              comment_amount: doc.data()["comment_amount"] + 1,
            });
          });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error: add comment failed" + error,
        });
      });
  });
}

/**
 * update the comment by comment id
 * @param {*} info :comment_id,is_delete
 * @returns status: 200, msg:ok
 * usage: updateCommentByIdApi(infoObj)
 */
async function updateCommentByIdApi(info) {
  return await new Promise((resolve, reject) => {
    commentListRef
      .doc(info.comment_id)
      .get()
      .then((doc) => {
        let mergeData = Object.assign(doc.data(), info);
        commentListRef.doc(info.comment_id).update(mergeData);

        resolve({
          status: 200,
          msg: "ok",
        });
      });

    bookRef
      .doc(info.book_id)
      .get()
      .then((doc) => {
        doc.ref.update({
          ...doc.data(),
          comment_amount: doc.data()["comment_amount"] - 1,
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "update comment amount" + error,
        });
      });
  });
}

/**
 * ========================================== Room ==========================================
 */

/**
 * Get all reading room
 * @returns {Promise<unknown>}
 */
async function getAllReadingRoomApi() {
  return await new Promise((resolve, reject) => {
    readingRoomRef.onSnapshot((querySnapshot) => {
      if (!querySnapshot.size)
        reject({
          status: 300,
          msg: "No room available",
        });

      let items = [];
      querySnapshot.forEach((doc) => {
        delete doc.data()["is_delete"];

        items.push({
          ...doc.data(),
          rest_amount:
            doc.data()["room_capacity"] - doc.data()["reader_amount"],
          is_available: Boolean(
            doc.data()["room_capacity"] - doc.data()["reader_amount"]
          ),
        });
      });

      // if success
      resolve({
        status: 200,
        msg: "ok",
        data: items,
      });
    });
  });
}

/**
 * ========================================== Seat ==========================================
 */

async function addSeatReserApi(info) {
  return await new Promise((resolve, reject) => {
    // 1. Check if a seat has been reserved
    seatReservationRef
      .where("user_id", "==", info.user_id)
      .where("is_delete", "==", false)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size) {
          reject({
            status: 300,
            msg: "You have reserved a seat!",
          });
        }

        // 2. Get Room thumbnail
        readingRoomRef
          .doc(info.room_id)
          .get()
          .then((doc) => {
            // 3. Query rest available seats of this room
            seatRef
              .where("room_id", "==", info.room_id)
              .where("is_available", "==", true)
              .get()
              .then((querySnapshot) => {
                if (!querySnapshot.size) {
                  reject({
                    status: 300,
                    msg: "No extra seat in this room!",
                  });
                }
                // 3. Assign the first seat to this user
                let seat_doc = querySnapshot.docs[0];
                let seat_id = seat_doc.data()["seat_id"];

                // 4. Add this reservation info to Seat_reservation collection
                let newInfo = {
                  user_id: info["user_id"],
                  seat_id: seat_id,
                  start_time: info["start_time"],
                  end_time: info["end_time"],
                  create_time: getTimestamp(),
                  return_time: getTimestamp(1),
                };
                seatReservationRef
                  .add(newInfo)
                  .then((docRef) => {
                    info.reservation_id = docRef.id;
                    info.is_delete = false;
                    docRef.update(info);

                    resolve({
                      status: 200,
                      msg: "ok",
                      data: {
                        reservation_id: docRef.id,
                      },
                    });
                  })
                  .catch((error) => {
                    reject({
                      status: 300,
                      msg:
                        "Error: rent seat failed: " +
                        info +
                        " Error msg: " +
                        error,
                    });
                  });

                // 5.Update state of this seat
                seat_doc.ref.update({
                  ...seat_doc.data(),
                  is_available: false,
                });

                // 6.Update reader_amount of this room
                readingRoomRef
                  .doc(info.room_id)
                  .get()
                  .then((doc) => {
                    doc.ref.update({
                      ...doc.data(),
                      reader_amount: doc.data()["reader_amount"] + 1,
                    });
                  })
                  .catch((err) => {
                    reject({
                      status: 300,
                      msg:
                        "Error: update reader_amount error " +
                        info +
                        " Error msg: " +
                        err,
                    });
                  });
              })
              .catch((error) => {
                reject({
                  status: 300,
                  msg:
                    "Error: update reader_amount error " +
                    info +
                    " Error msg: " +
                    error,
                });
              });
          })
          .catch((err) => {
            reject({
              status: 300,
              msg: "Error: get room thumbnail failed. Error msg: " + err,
            });
          });
      })
      .catch((err) => {
        reject({
          status: 300,
          msg: "Error: query user error. Error msg: " + err,
        });
      });
  });
}

async function updateSeatReserApi(info) {
  return await new Promise((resolve, reject) => {
    //judge if the input info is correct in database
    seatReservationRef
      .doc(info.reservation_id)
      .get()
      .then((doc) => {
        let item = doc.data();
        Object.assign(item, info);
        doc.ref.update(item);

        if (item.is_delete) {
          readingRoomRef
            .doc(item.room_id)
            .get()
            .then((doc) => {
              readingRoomRef.doc(item.room_id).update({
                ...doc.data(),
                reader_amount: doc.data()["reader_amount"] - 1,
              });
            })
            .catch((err) => {
              reject({
                status: 300,
                msg: "Reduce reader amount error. Error msg: " + err,
              });
            });

          seatRef
            .doc(item.seat_id)
            .get()
            .then((doc) => {
              seatRef.doc(item.seat_id).update({
                ...doc.data(),
                is_available: true,
              });
            });
        }

        resolve({
          data: item,
          status: 200,
          msg: "ok",
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Seat Reservation update error " + info + " Error msg: " + error,
        });
      });
  });
}

/**
 * ========================================== Model ==========================================
 */

/**
 * User signup
 * @param info: user's information
 * @return: { status: 200, msg: "ok" }
 * @usage: signup(infoObj)
 */
async function addUserModelApi(info) {
  return await new Promise((resolve, reject) => {
    userModelRef
      .add(info)
      .then((doc) => {
        info.is_delete = false;
        doc.update(info);

        resolve({
          status: 200,
          msg: "ok",
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error: add user model failed: " + info + " Error msg: " + error,
        });
      });
  });
}

/**
 * User signup
 * @param info: user's information
 * @return: { status: 200, msg: "ok" }
 * @usage: signup(infoObj)
 */
async function updateUserModelApi(info) {
  return await new Promise((resolve, reject) => {
    userModelRef
      .where("user_id", "==", info.user_id)
      .get()
      .then((querySnapshot) => {
        let doc = querySnapshot.docs[0];
        let newInfo = Object.assign(doc.data(), info);
        doc.ref.update(newInfo);

        resolve({
          status: 200,
          msg: "ok",
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg:
            "Error: update user model failed: " + info + " Error msg: " + error,
        });
      });
  });
}

/**
 * get users' record of book reservation
 * @param {*} id: user_id
 * @returns user_id, book_id, start_time, end_time
 * usage:getUserBookReservationApi(id)
 */
async function getUserBookReservationApi(id) {
  return await new Promise((resolve, reject) => {
    bookReserRef
      .where("user_id", "==", id)
      .where("is_delete", "==", false)
      .get()
      .then((querySnapShot) => {
        if (querySnapShot.empty) {
          resolve({
            data: [],
            status: 200,
            msg: "ok",
          });
        }

        let reservation_list = [];
        let promises = [];

        querySnapShot.forEach((doc) => {
          let item = doc.data();
          delete item["create_time"];
          delete item["return_time"];
          delete item["is_delete"];

          let promise = bookRef
            .doc(item["book_id"])
            .get()
            .then((doc) => {
              item["book_name"] = doc.data()["book_name"];
              item["author"] = doc.data()["author"];
              item["thumbnail"] = doc.data()["thumbnail"];

              reservation_list.push(item);
            })
            .catch((err) => {
              reject({
                status: 300,
                msg: "Get book info failed: " + err,
              });
            });

          promises.push(promise);
        });

        Promise.all(promises)
          .then(() => {
            resolve({
              data: reservation_list,
              status: 200,
              msg: "ok",
            });
          })
          .catch((err) => {
            reject({
              status: 300,
              msg: "Show book reservation record" + err,
            });
          });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Show book reservation record" + error,
        });
      });
  });
}

async function getAllModelApi() {
  return await new Promise((resolve, reject) => {
    modelRef.onSnapshot((querySnapshot) => {
      let res = [];
      querySnapshot.forEach((doc) => {
        delete doc.data()["is_delete"];
        res.push(doc.data());
      });

      resolve({
        status: 200,
        msg: "ok",
        data: res,
      });
    });
  });
}

/**
 * ========================================== User ==========================================
 */

/**
 * User signup
 * @param info: user's information
 * @return: { status: 200, msg: "ok" }
 * @usage: signup(infoObj)
 */
async function signupApi(info) {
  return await new Promise((resolve, reject) => {
    userRef
      .where("email", "==", info.email)
      .get()
      .then((queryRes) => {
        if (queryRes.size) {
          reject({
            status: 300,
            msg: "Error: email already exists",
          });
        } else {
          userRef
            .add(info)
            .then((doc) => {
              // Update the document with its ID
              info.user_id = doc.id;
              info.is_delete = false;
              doc.update(info);

              resolve({
                status: 200,
                msg: "ok",
              });
            })
            .catch((error) => {
              reject({
                status: 300,
                msg: "Error: add user failed: " + info + " Error msg: " + error,
              });
            });
        }
      });
  });
}

/**
 * update user info
 * @param info: user's information
 * @return:  status: 200, msg: "ok"
 * @usage: updateUserInfoApi(infoObj)
 */
async function updateUserInfoApi(info) {
  return await new Promise((resolve, reject) => {
    userRef
      .where("user_id", "==", info.user_id)
      .get()
      .then((querySnapShot) => {
        querySnapShot.forEach((doc) => {
          let item = doc.data();
          Object.assign(item, info); // update user info here

          userRef
            .doc(item.user_id)
            .update(item)
            .then(() => {
              delete item["is_delete"];
              resolve({
                status: 200,
                msg: "ok",
                data: item,
              });
            })
            .catch((err) => {
              reject({
                status: 300,
                msg:
                  "Error: update user failed: " + info + " Error msg: " + err,
              });
            });
        });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error: update user failed: " + info + " Error msg: " + error,
        });
      });
  });
}

/**
 * user login
 * @param  info: email and password
 * @returns  user details, status:200, msg:"ok"
 */

async function logInApi(info) {
  return await new Promise((resolve, reject) => {
    //judge if the input info is correct in database
    userRef
      .where("email", "==", info.email)
      .where("password", "==", info.password)
      .get()
      .then((querySnapshot) => {
        // Judge the result of same email and password
        if (querySnapshot.empty) {
          reject({
            status: 300,
            msg: "The user does not exist or password is wrong!",
          });
        } else {
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            delete item["is_delete"];

            resolve({
              data: item,
              status: 200,
              msg: "ok",
            });
          });
        }
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "log in error " + info + " Error msg: " + error,
        });
      });
  });
}

/**
 * Get User's seat info
 * @param user_id:
 * @returns {Promise<unknown>}
 */
async function getUserSeatInfoApi(user_id) {
  return await new Promise((resolve, reject) => {
    //judge if the input info is correct in database
    seatReservationRef
      .where("user_id", "==", user_id)
      .where("is_delete", "==", false)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size) {
          let item = querySnapshot.docs[0].data();
          readingRoomRef
            .doc(item.room_id)
            .get()
            .then((doc) => {
              item["thumbnail"] = doc.data()["thumbnail"];
              item["room_name"] = doc.data()["room_name"];

              resolve({
                data: item,
                status: 200,
                msg: "ok",
              });
            });
        } else {
          resolve({
            data: [],
            status: 200,
            msg: "ok",
          });
        }
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error msg: " + error,
        });
      });
  });
}

/**
 * Get User Model Info
 * @param user_id:
 * @returns {Promise<unknown>}
 */
async function getUserModelInfoApi(user_id) {
  return await new Promise((resolve, reject) => {
    userModelRef
      .where("user_id", "==", user_id)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          resolve({
            data: {},
            status: 200,
            msg: "ok",
          });
        }

        let item = querySnapshot.docs[0].data();
        modelRef
          .doc(item.model_id)
          .get()
          .then((doc) => {
            item.thumbnail = doc.data()["thumbnail"];
            item.model_name = doc.data()["model_name"];
            item.create_time = doc.data()["create_time"];

            delete item["is_delete"];

            resolve({
              data: item,
              status: 200,
              msg: "ok",
            });
          })
          .catch((err) => {
            reject({
              status: 300,
              msg: "Error msg: " + err,
            });
          });
      })
      .catch((error) => {
        reject({
          status: 300,
          msg: "Error msg: " + error,
        });
      });
  });
}

function getTimestamp(delay = 0) {
  let timestamp = new Date().getTime();
  let date = new Date(timestamp);
  date.setDate(date.getDate() + delay);
  return date.getTime();
}

export {
  addSeatReserApi,
  updateSeatReserApi,
  addUserModelApi,
  updateUserModelApi,
  getAllModelApi,
  getUserModelInfoApi,
  getBookByIdApi,
  getBookRecommendListApi,
  getCategoriesApi,
  getAllBookApi,
  addBookRentApi,
  updateRentBookApi,
  getUserSeatInfoApi,
  signupApi,
  updateUserInfoApi,
  logInApi,
  getAllCommentByBookIdApi,
  addCommentByBookIdApi,
  getAllReadingRoomApi,
  getUserBookReservationApi,
  updateCommentByIdApi,
  updateRecommendAmountApi,
};
